module.exports = __webpack_public_path__ + "static/img/katakana_small_a-compressor.b6aa8d8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/katakana_small_a-compressor.gif
// module id = 4sfa
// module chunks = 0